import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { ReactNode, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { ActionButton, Fade, SectionContainer, SectionHeader, SectionLabel } from "./style";

interface SectionProps {
    isOpen: boolean;
    label: string;
    hasBorder: boolean;
    hasMarginTop: boolean;
    children?: ReactNode;
    showActions?: boolean;
    onDelete?: () => void;
    onDuplicate?: () => void;
    isFixed?: boolean;
}

export const Section = ({ isOpen = true, label, hasBorder = false, hasMarginTop = false, children, showActions = false, onDelete, onDuplicate, isFixed = false }: SectionProps) => {
    const [open, setOpen] = useState(isFixed ? true : isOpen);

    const CustomToggle = React.forwardRef(({ children, onClick }: any, ref: any) => (
        <ActionButton
            ref={ref}
            onClick={(e: any) => {
                e.preventDefault();
                onClick(e);
            }}
        >
            {children}
        </ActionButton>
    ));

    const handleToggle = () => {
        if (!isFixed) {
            setOpen(!open);
        }
    };

    return (
        <SectionContainer className={`${hasBorder ? 'section-border' : ''} ${hasMarginTop ? 'mt-5' : ''}`}>
            <SectionHeader>
                <SectionLabel onClick={handleToggle} aria-controls="section-1" aria-expanded={open} style={{ cursor: isFixed ? 'default' : 'pointer' }}>
                    {!isFixed && <FontAwesomeIcon icon={open ? ['fas', 'chevron-up'] : ['fas', 'chevron-down']} style={{ color: !open ? 'var(--grey)' : 'var(--primary)' }} />}
                    <span style={{ color: !open ? 'var(--grey)' : 'var(--primary)' }}>{label}</span>
                </SectionLabel>
                {(showActions && open) && (
                    <Dropdown className="dropdown-section-menu">
                        <Dropdown.Toggle as={CustomToggle}>
                            <FontAwesomeIcon icon={['fas', 'ellipsis-v']} />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            {onDelete && <Dropdown.Item onClick={onDelete}>Excluir</Dropdown.Item>}
                            {onDuplicate && <Dropdown.Item onClick={onDuplicate}>Duplicar</Dropdown.Item>}
                        </Dropdown.Menu>
                    </Dropdown>
                )}
            </SectionHeader>
            <Fade in={open} mountOnEnter unmountOnExit>
                <div style={{ width: '100%' }}>
                    {children}
                </div>
            </Fade>
        </SectionContainer>
    );
};